import {DatePipe, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IconsModule} from '@app/components/kit/icons/icons.module';
import {JsonSchemaRendererModule} from '@app/components/renderer/json-schema-renderer.modul';
import {NgModule} from '@angular/core';
import {ParticipantCreateComponent} from './create/participant-create.component';
import {ParticipantEditComponent} from './edit/participant-edit.component';
import {ParticipantInfoComponent} from './dashboard/participant-info.component';
import {ParticipantListComponent} from './list/participant-list.component';
import {ParticipantsRouterModule} from './participants-routing.module';
import {ParticipantWorkflowComponent} from './workflow/participant-workflow.component';
import { ParticipantWorkflowListComponent } from '@app/pages/participant/list/participant-workflow-list.component';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {ProjektFlowchartModule} from '../projektflowchart/projektflowchart.module';
import {SharedModule} from 'src/app/shared.module';
import {WidgetsComponentsModule} from 'src/app/components/kit/widgets/widgets-components.module';
import {WorkflowModule} from '@workflow/workflow.module';
import {ElementsModule} from '@app/components/elements/elements.module';
import {LayoutModule} from '@app/components/cleanui/layout/layout.module';
import {ReportModule} from '@workflow/components/report/report.module';
import { UiShowcaseModule } from '@app/pages/ui-showcase/ui-showcase.module';

const COMPONENTS = [
	ParticipantCreateComponent,
	ParticipantEditComponent,
	ParticipantInfoComponent,
	ParticipantListComponent,
	ParticipantWorkflowComponent,
	ParticipantWorkflowListComponent,
];

@NgModule({
	imports: [
		FormsModule,
		IconsModule,
		JsonSchemaRendererModule,
		PerfectScrollbarModule,
		ProjektFlowchartModule,
		ReactiveFormsModule,
		SharedModule,
		ParticipantsRouterModule,
		WidgetsComponentsModule,
		WorkflowModule,
		ElementsModule,
		LayoutModule,
		ReportModule,
		UiShowcaseModule,
	],
	declarations: [...COMPONENTS],
	providers: [
		DatePipe,
		DecimalPipe
	]
})
export class ParticipantsModule {}
